import { checkHttpStatus, parseJSON, expiredToken } from '../../utils/response';
import { Token, UserCode, EmployeeId } from '../../utils/users';
import { errorResponse } from '../../utils/response';
import * as storage from '../../utils/storage';

export function acceptTermsUse() {

    const param = JSON.stringify({
        userCode: UserCode(),
        employeeId: EmployeeId(),
        token: Token()
    });

    return fetch('termsUse/acceptTerms', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                if (response.status) {
                    storage.saveAcceptedTermsUse(true);
                }

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}